export default __webpack_public_path__ + "static/media/home-page-new-faqs.5b65b0eb.png";